import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography,
} from '@mui/material'

// Resuelve los estados actuales del cajero agrupados por categoria.
// estadosCajero puede venir como arreglo de ids o de objetos {estado: id}.
function resolverEstados(categoriasEstados, estadosCajero) {
  const idsCajero = (estadosCajero || []).map((e) =>
    e && typeof e === 'object' ? e.estado : e
  )

  const items = []
  ;(categoriasEstados || []).forEach((categoria) => {
    const tipos = []
    categoria.tipos.forEach((tipo) => {
      let estadoActual = null
      let estadoDesconocido = null
      tipo.estados.forEach((estado) => {
        if (estado.codigo_estado === 0) estadoDesconocido = estado
        if (idsCajero.includes(estado.id)) estadoActual = estado
      })
      const resuelto = estadoActual || estadoDesconocido
      if (resuelto) {
        tipos.push({
          tipoId: tipo.id,
          descripcion: resuelto.descripcion,
          archivo: resuelto.archivo,
          codigo: resuelto.codigo_estado,
        })
      }
    })
    if (tipos.length > 0) {
      items.push({ categoriaId: categoria.id, nombre: categoria.nombre, tipos })
    }
  })
  return items
}

function ItemEstadoCajero(props) {
  const categorias = resolverEstados(props.categoriasEstados, props.estadosCajero)

  const totales = categorias.reduce(
    (acc, c) => {
      c.tipos.forEach((t) => {
        if (t.codigo === 0) acc.desconocidos += 1
        else acc.ok += 1
      })
      return acc
    },
    { ok: 0, desconocidos: 0 }
  )

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '14px',
        border: '1px solid rgba(0,0,0,0.06)',
        backgroundColor: '#fff',
        height: '100%',
      }}
    >
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1} sx={{ mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#222' }}>
            Estado del cajero
          </Typography>
          <Stack direction="row" gap={0.75} flexWrap="wrap">
            <Chip
              size="small"
              label={`${totales.ok} reportados`}
              sx={{ backgroundColor: '#E8F5E9', color: '#2E7D32', fontWeight: 600 }}
            />
            {totales.desconocidos > 0 && (
              <Chip
                size="small"
                label={`${totales.desconocidos} sin reporte`}
                sx={{ backgroundColor: '#F5F5F5', color: '#666', fontWeight: 600 }}
              />
            )}
          </Stack>
        </Stack>

        <Divider sx={{ mb: 1.5 }} />

        {categorias.length === 0 ? (
          <Typography variant="body2" sx={{ color: '#888' }}>
            Sin estados reportados.
          </Typography>
        ) : (
          categorias.map((cat) => (
            <Box key={cat.categoriaId} sx={{ mb: 1.5 }}>
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  fontWeight: 700,
                  color: '#6A9E2C',
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  mb: 0.5,
                }}
              >
                {cat.nombre}
              </Typography>
              <Stack gap={0.5}>
                {cat.tipos.map((t) => (
                  <Stack
                    key={t.tipoId}
                    direction="row"
                    alignItems="center"
                    gap={1}
                    sx={{
                      py: 0.5,
                      px: 1,
                      borderRadius: '8px',
                      backgroundColor: t.codigo === 0 ? 'rgba(0,0,0,0.025)' : 'transparent',
                    }}
                  >
                    <img
                      alt="estado"
                      src={'/estado_cajero/' + t.archivo}
                      width={16}
                      height={16}
                      style={{ flexShrink: 0 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ color: t.codigo === 0 ? '#888' : '#333', fontSize: '0.82rem' }}
                    >
                      {t.descripcion}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
          ))
        )}
      </CardContent>
    </Card>
  )
}

export default ItemEstadoCajero
